// frontend/src/components/Admin/sidebar.js

import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/SenseAbleIcon.svg";
import { useSelector } from "react-redux";
import { Badge } from "react-bootstrap"; 
import "./AdminCSS/alertpage.css";

const Sidebar = ({ onOptionClick }) => {
  // Get unacknowledged alerts count from Redux alerts slice
  const alerts = useSelector((state) => state.alerts.alerts || []);
  const unacknowledgedCount = alerts.filter((alert) => !alert.acknowledged).length;
  const unreadCount = useSelector(
    (state) => state.notifications.notifications.length
    // state.notifications.notifications.filter((alert) => !alert.read).length
  );

  return (
    <div className="custom-sidebar">
      <div className="logo text-center py-3">
        <Logo className="sidebar-logo" />
      </div>
      <ul className="sidebar-menu">
        <li>
          <Link to="#" onClick={() => onOptionClick("dashboard")}>
            Dashboard
          </Link>
        </li>
        <li className="dropdown">
          <span>Operations</span>
          <ul className="dropdown-menu">
            <li>
              <Link to="/admin/adduser">Add User</Link>
            </li>
            <li>
              <Link to="/admin/adddevice">Add Device</Link>
            </li>
            <li>
              <Link to="/admin/addadmin">Add Admin</Link>
            </li>
            <li>
              <Link to="/admin/addpatient">Add Patient</Link>
            </li>
            <li>
              <Link to="/admin/assign-device">Assign Device</Link>
            </li>
            <li>
              <Link to="/admin/assign-user">Assign User</Link>
            </li>
          </ul>
        </li>
        <li>
          <Link to="#" onClick={() => onOptionClick("users")}>
            Users
          </Link>
        </li>
        <li>
          <Link to="#" onClick={() => onOptionClick("admins")}>
            Admins
          </Link>
        </li>
        <li>
          <Link to="#" onClick={() => onOptionClick("devices")}>
            Devices
          </Link>
        </li>
        <li>
          <Link to="#" onClick={() => onOptionClick("patients")}>
            Patients
          </Link>
        </li>
        {/* <li>
          <Link to="#" onClick={() => onOptionClick("bluetooth-wifi-connect")}>
            BluetoothWiFiConnect
          </Link>
        </li> */}
         <li>
          <Link to="#" onClick={() => onOptionClick("admin-alerts")}>
          Alerts
            {/* Show badge After Alerts text if there are any unacknowledged alerts */}
            {unacknowledgedCount > 0 && (
              <Badge bg="danger" pill className="me-1">
                {unacknowledgedCount}
              </Badge>
            )}
            
          </Link>
        </li>
        {/* <li>
          <Link to="#" onClick={() => onOptionClick("fall-alerts")}>
            Fall Alerts{" "}
            {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
          </Link>
        </li> */}
        <li>
          <Link to="settings">Settings</Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
